var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stats" }, [
    _c("div", { staticClass: "stats-item" }, [
      _c("span", { staticClass: "stats-item__label" }, [_vm._v("Всего ТМЦ:")]),
      _c("span", { staticClass: "stats-item__value" }, [
        _vm._v(
          " " + _vm._s(_vm.filtered.total) + "/" + _vm._s(_vm.total.total)
        ),
      ]),
    ]),
    _c("div", { staticClass: "stats-item" }, [
      _c("span", { staticClass: "stats-item__label" }, [_vm._v("Выдано:")]),
      _c("span", { staticClass: "stats-item__value" }, [
        _vm._v(
          " " + _vm._s(_vm.filtered.issued) + "/" + _vm._s(_vm.total.issued)
        ),
      ]),
    ]),
    _c("div", { staticClass: "stats-item" }, [
      _c("span", { staticClass: "stats-item__label" }, [_vm._v("Свободно:")]),
      _c("span", { staticClass: "stats-item__value" }, [
        _vm._v(" " + _vm._s(_vm.filtered.free) + "/" + _vm._s(_vm.total.free)),
      ]),
    ]),
    _c("div", { staticClass: "stats-item" }, [
      _c("span", { staticClass: "stats-item__label" }, [_vm._v("Списано:")]),
      _c("span", { staticClass: "stats-item__value" }, [
        _vm._v(
          " " +
            _vm._s(_vm.filtered.writtenOff) +
            "/" +
            _vm._s(_vm.total.writtenOff)
        ),
      ]),
    ]),
    _c("div", { staticClass: "stats-item" }, [
      _c(
        "span",
        { staticClass: "stats-item__label stats-item__label--warning" },
        [_vm._v("Из них просрочено:")]
      ),
      _c("span", { staticClass: "stats-item__value" }, [
        _vm._v(
          " " + _vm._s(_vm.filtered.expired) + "/" + _vm._s(_vm.total.expired)
        ),
      ]),
    ]),
    _c("div", { staticClass: "stats-item" }, [
      _c("span", { staticClass: "stats-item__label" }, [
        _vm._v("Общая стоимость, ฿:"),
      ]),
      _c("span", { staticClass: "stats-item__value" }, [
        _vm._v(
          " " +
            _vm._s(_vm.filtered.cost.toLocaleString()) +
            "/" +
            _vm._s(_vm.total.cost.toLocaleString())
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }